import {
  DesignSystemVersionValues,
  IUserSettings,
  NotificationSettings,
  ResUserSettings,
  ResUserSettingsCore,
  SectionViews,
  UserPropertyType
} from '../entities/user_settings';
import { BaseOrganizationEndpoints } from './base';
import { ResponseWithStatus } from './response/response_with_status';

export class UserSettings extends BaseOrganizationEndpoints {
  async createOrUpdate(
      type: UserPropertyType,
      value: string
  ): Promise<ResponseWithStatus<IUserSettings>> {
    return this.requestWithStatus<IUserSettings>('POST', '/user/settings', {
      type,
      value
    });
  }

  async getByType(
      type: UserPropertyType
  ): Promise<ResponseWithStatus<IUserSettings>> {
    return this.requestWithStatus<IUserSettings>(
        'GET',
        `/user/settings/${type}`
    );
  }

  async getAll() {
    return this.requestWithStatus<ResUserSettings>('GET', '/user/settings');
  }

  async getCoreUserSettings() {
    return this.requestWithStatus<ResUserSettingsCore>('GET', '/v1/settings/user');
  }

  /**
   * Updates the personal week start override (0=Sunday..6=Saturday).
   * Pass -1 to clear the override and inherit the organization setting.
   */
  async updateWeekStartsOn(value: number) {
    return this.requestWithStatus('PUT', '/v1/settings/user', {
      week_starts_on: value
    });
  }

  /**
   * Replaces the whole `views` object. The backend does not merge this field:
   * whatever is sent wins, so callers must send the result of a full
   * read-modify-write, never just the area they touched.
   */
  async updateViews(views: SectionViews) {
    return this.requestWithStatus<ResUserSettingsCore>(
        'PUT',
        '/v1/settings/user',
        { views }
    );
  }

  async getDesignSystem() {
    const res = await this.requestWithStatus<ResUserSettingsCore>(
        'GET',
        '/v1/settings/user'
    );
    const result = res.result;
    return result?.settings.design_system_version;
  }

  async getNotificationSettings() {
    const res = await this.requestWithStatus<ResUserSettingsCore>(
        'GET',
        '/v1/settings/user'
    );
    const result = res.result;
    return result?.settings.notification_settings;
  }

  async updateDesignSystem(value: DesignSystemVersionValues) {
    return this.requestWithStatus('PUT', '/v1/settings/user', {
      [UserPropertyType.DesignSystemVersion]: value
    });
  }

  async updateIntegrationSettings(data: Partial<NotificationSettings>) {
    return this.requestWithStatus('PUT', '/v1/settings/user', {
      notification_settings: data
    });
  }
}
